import React from 'react';
import { TableCell, TableSortLabel, Tooltip } from '@mui/material';

export default function SortableTableHeaderCell({
    columnId,
    label,
    title,
    orderBy,
    order,
    onSort,
    align,
    sx,
    wrap = false,
}) {
    const active = orderBy === columnId;
    const tooltipTitle = title && title !== label ? title : '';

    return (
        <TableCell align={align} sx={sx} sortDirection={active ? order : false}>
            <Tooltip title={tooltipTitle} arrow disableHoverListener={!tooltipTitle}>
                <TableSortLabel
                    active={active}
                    direction={active ? order : 'asc'}
                    onClick={() => onSort(columnId)}
                    sx={{
                        whiteSpace: wrap ? 'normal' : 'nowrap',
                        maxWidth: '100%',
                        lineHeight: wrap ? 1.25 : undefined,
                        alignItems: wrap ? 'flex-start' : undefined,
                    }}
                >
                    {label}
                </TableSortLabel>
            </Tooltip>
        </TableCell>
    );
}
